import { useLanguage } from '../utils/LanguageContext';
import { ValidatedForm, FormInput, FormSubmit, FormChoice } from './common/ValidatedForm';
import { useAuth } from '../utils/AuthContext.js';
import translations from './ComponentsTranslations.lang.json';
import { PayrollElectionType } from '../shared/constants/employmentConstants.js';
import {
  PAYROLL_CONTRIBUTION_PERCENT_MIN,
  PAYROLL_CONTRIBUTION_PERCENT_MAX,
  PAYROLL_CONTRIBUTION_DOLLARS_MIN,
  PAYROLL_CONTRIBUTION_DOLLARS_MAX,
  updateUserEmploymentPayrollElectionSchema,
} from '../shared/validations/userValidations.js';

const { CONTRIBUTION_PERCENT, CONTRIBUTION_DOLLARS } = PayrollElectionType;

const PayrollElectionForm = ({ employment, onFinish, submitLabel }) => {
  const { optionsForEnum } = useLanguage(translations);
  const { api } = useAuth();

  if (!employment) {
    return null;
  }

  const { employmentId, employeeRequestedPayrollElection } = employment;

  const typeField = 'employeeRequestedPayrollElection.electionType';
  const percentField = 'employeeRequestedPayrollElection.electionPercent';
  const dollarsField = 'employeeRequestedPayrollElection.electionDollars';

  return (
    <ValidatedForm
      key="payrollElection"
      schema={updateUserEmploymentPayrollElectionSchema}
      initialValues={{ employeeRequestedPayrollElection }}
      preValidation={({ watch, clearValue }) => {
        const electionType = watch(typeField);
        electionType !== CONTRIBUTION_PERCENT && clearValue(percentField);
        electionType !== CONTRIBUTION_DOLLARS && clearValue(dollarsField);
      }}
      handleSubmit={async (values) => await api.requestPayrollElection(employmentId, values)}
      onFinish={onFinish}
    >
      <FormChoice name={typeField} options={optionsForEnum(PayrollElectionType)} type="radio" />
      {({ watch }) => {
        const electionType = watch(typeField);
        return (
          <>
            {electionType === CONTRIBUTION_PERCENT && (
              <FormInput
                name={percentField}
                type="percent"
                min={PAYROLL_CONTRIBUTION_PERCENT_MIN}
                max={PAYROLL_CONTRIBUTION_PERCENT_MAX}
              />
            )}
            {electionType === CONTRIBUTION_DOLLARS && (
              <FormInput
                name={dollarsField}
                type="dollars"
                min={PAYROLL_CONTRIBUTION_DOLLARS_MIN}
                max={PAYROLL_CONTRIBUTION_DOLLARS_MAX}
              />
            )}
          </>
        );
      }}
      <FormSubmit>{submitLabel}</FormSubmit>
    </ValidatedForm>
  );
};

export default PayrollElectionForm;
